import { Target04Icon, XCloseIcon } from '@/components/ui/icons'
import {
	Select,
	SelectContent,
	SelectItem,
	SelectTrigger,
	SelectValue
} from '@/components/ui/select'
import { submissionTypeOptions } from '@/features/luxe-submissions/utils'
import { useTranslation } from '@/translations/i18n'

interface SubmissionTypeFilterSelectProps {
	value: string | null
	onChange: (value: string | null) => void
}

export function SubmissionTypeFilterSelect({
	value,
	onChange
}: SubmissionTypeFilterSelectProps) {
	const { t } = useTranslation()
	const selectedOption = submissionTypeOptions.find(
		(opt) => opt.value === value
	)

	const handleValueChange = (newValue: string | null) => {
		// Toggle off if same value selected
		onChange(newValue === value ? null : newValue)
	}

	return (
		<Select modal onValueChange={handleValueChange} value={value}>
			<SelectTrigger
				className='h-10 min-w-0 gap-2 border-neutral-300 bg-neutral-white px-3 text-neutral-700 text-sm shadow-none hover:shadow-none data-[popup-open]:shadow-none [&>svg]:text-neutral-500'
				nativeButton={false}
				size='sm'
			>
				<SelectValue className='min-w-0'>
					<span className='flex min-w-0 items-center gap-2'>
						<Target04Icon className='shrink-0' size={20} />
						{selectedOption ? (
							<>
								<span className='truncate'>
									{t(selectedOption.label)}
								</span>
								<button
									className='flex size-5 shrink-0 cursor-pointer items-center justify-center rounded-full text-neutral-500 hover:bg-neutral-200 hover:text-neutral-700'
									onClick={(e: React.MouseEvent) => {
										e.stopPropagation()
										e.preventDefault()

										onChange(null)
									}}
									onPointerDown={(e: React.MouseEvent) => {
										e.stopPropagation()
										e.preventDefault()
									}}
									type='button'
								>
									<XCloseIcon size={14} />
								</button>
							</>
						) : (
							<span className='truncate font-medium text-neutral-900'>
								{t('luxe_submissions:submission_type_column')}
							</span>
						)}
					</span>
				</SelectValue>
			</SelectTrigger>
			<SelectContent className='w-(--anchor-width) min-w-50'>
				{submissionTypeOptions.map((option) => (
					<SelectItem
						className='whitespace-normal!'
						key={option.value}
						value={option.value}
					>
						{t(option.label)}
					</SelectItem>
				))}
			</SelectContent>
		</Select>
	)
}
